module.exports = __webpack_public_path__ + "img/evolution.9b24f249.582ae2ca.png";